import { render, staticRenderFns } from "./DisplayLocationLabel.vue?vue&type=template&id=6162a2aa&scoped=true&"
import script from "./DisplayLocationLabel.vue?vue&type=script&lang=js&"
export * from "./DisplayLocationLabel.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLocationLabel.vue?vue&type=style&index=0&id=6162a2aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162a2aa",
  null
  
)

export default component.exports